import { Select, SelectProps } from '@mantine/core'

export default function BlackSelectInput({ classNames, ...props }: SelectProps) {
  return (
    <Select
      classNames={{
        label: "black-input-label",
        input: "black-select-input-input",
        root: "black-text-input-root",
        rightSection: "customRightSection",
        ...classNames
      }}
      {...props}
    />
  )
}
